/**
 * @generated SignedSource<<60ef7afb0976d3049b9e4501402f16aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendGuestOrderClaimEmailInput = {
  clientMutationId?: string | null;
  orderId: string;
};
export type invoiceEmailActions_SendGuestOrderClaimEmailMutation$variables = {
  input: SendGuestOrderClaimEmailInput;
};
export type invoiceEmailActions_SendGuestOrderClaimEmailMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly sendGuestOrderClaimEmail: {
        readonly clientMutationId: string | null;
        readonly sentToInvoiceEmail: string;
      } | null;
    };
  };
};
export type invoiceEmailActions_SendGuestOrderClaimEmailMutation = {
  response: invoiceEmailActions_SendGuestOrderClaimEmailMutation$data;
  variables: invoiceEmailActions_SendGuestOrderClaimEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "SendGuestOrderClaimEmailPayload",
            "kind": "LinkedField",
            "name": "sendGuestOrderClaimEmail",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentToInvoiceEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "invoiceEmailActions_SendGuestOrderClaimEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "invoiceEmailActions_SendGuestOrderClaimEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa340431a524d360df3b5f129d49ac4e",
    "id": null,
    "metadata": {},
    "name": "invoiceEmailActions_SendGuestOrderClaimEmailMutation",
    "operationKind": "mutation",
    "text": "mutation invoiceEmailActions_SendGuestOrderClaimEmailMutation(\n  $input: SendGuestOrderClaimEmailInput!\n) {\n  Admin {\n    Billing {\n      sendGuestOrderClaimEmail(input: $input) {\n        sentToInvoiceEmail\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "00c7c48b82b9d422c7593c1386b1f3e2";

export default node;
